import CreatePlatformNotificationsModal from './CreatePlatformNotificationModal.vue'

export default CreatePlatformNotificationsModal